import { render, staticRenderFns } from "./Panelprocedimientos.vue?vue&type=template&id=7605d2fd"
import script from "./Panelprocedimientos.vue?vue&type=script&lang=js"
export * from "./Panelprocedimientos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports